import React, { useEffect, useState } from 'react';
import "../../Styles/AboutUs.scss";

import MissionAndVision from './MissionAndVision';
import WhyChooseVizzhy from './WhyChooseVizzhy';
import WhoWeAre from './WhoWeAre';
import PersonalizedHealthcare from './PersonalizedHealthcare';
import TailoredServices from './TailoredServices';
import JoinUs from './JoinUs';
import ImpactOfMultiOmics from './ImpactOfMultiOmics';
import MobileViewPersonalizedHealthcare from './MobileViewAboutUs/MobileViewPersonalizedHealthcare';
import MobileViewWhyChooseVizzhy from './MobileViewAboutUs/MobileViewWhyChooseVizzhy';
import MobileViewTailoredServices from './MobileViewAboutUs/MobileViewTailoredServices';

// Mobile-View our approach
import MobileViewOurApproach from '../OurPlatForm/MobileViewOurPlatForm/MobileViewOurApproach';

function AboutUs() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [window.innerWidth]);

  return (
    <div className="aboutus w-100 pt-4">
      {/* Mobile View */}
      {isMobile ? (
        <>
        <div className="mobile-view-part-1">
          <MobileViewPersonalizedHealthcare />
        </div>

        <div className='mobile-view-part-2'>
        <WhoWeAre />
        </div>

        <div className='mobile-view-part-3'>
        <MissionAndVision />
        </div>

        {/* <div className='mobile-view-part-4'>
        <ImpactOfMultiOmics />
        </div> */}

        <div className='mobile-view-part-5'>
        <MobileViewWhyChooseVizzhy />
        </div>

        <div className='mobile-view-part-6'>
        <MobileViewTailoredServices />
        </div>

        <div className='mobile-view-part-7'>
        <JoinUs />
        </div>
        </>
      ) : (
        <>
        {/* web and tab view*/}
          <div className="part-1">
            <PersonalizedHealthcare />
          </div>
          <div className="part-2">
            <WhoWeAre />
          </div>
          <div className="part-3">
            <MissionAndVision />
          </div>
          <div className="part-4">
            <ImpactOfMultiOmics />
          </div>
          <div className="part-5">
            <WhyChooseVizzhy />
          </div>
          <div className="part-6">
            <TailoredServices />
          </div>
          <div className="part-7">
            <JoinUs />
          </div>
        </>
      )}
    </div>
  );
}

export default AboutUs;
